import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'
import { useTime } from '../../customHooks/useTime'

// `end` prop should also be a Luxon DateTime, preferably in the future.
const Countdown = (props) => {
  const [counter, setCounter] = useState(0)
  const now = useTime(200); // this countdown will queue a re-render every 200ms.
  // (it will try to update every 200ms)
  // Luxon `DateTime`: https://moment.github.io/luxon/docs/class/src/datetime.js~DateTime.html#instance-method-diff
  const diff = props.end.diff(now);
  // Luxon `Duration`: https://moment.github.io/luxon/docs/class/src/duration.js~Duration.html#instance-method-toFormat
  const formattedDuration = diff.toFormat('hh:mm:ss');
  useEffect(() => {
    if (formattedDuration === "00:10:00" && counter === 0) {
      toast.warning('Você só tem mais 10 minutos de prova!')
      setCounter(1)
    }
    if (diff)
      if (props.end <= now)
        props.action()
  }, [props, now])
  return (
    <h5>{formattedDuration}</h5>
  );
}

export default Countdown;